<template>
  <div class="wai">
    <div class="login" id="focus" @keypress="enterMenthod()">
      <ul>
        <li style="font-size:24px;color:#fff">
          <span style="padding:20px"><img src="../../assets/管理.png"/></span
          >纬　普
        </li>
        <li style="margin:40px 0 20px 0">
          <span style="background-color:#28b779;padding:12px 15px 11px 15px "
            ><img
              style="width:20px;height:20px"
              src="../../assets/userLogin.png"/></span

          ><input
            v-model="userInfo"
            placeholder="请输入用户名"
            style="border:none;width:450px;height:38px;text-indent:10px;"
          />
        </li>

        <li style="margin:40px 0 20px 0">
          <span style="background-color:#ffb848;padding:12px 15px 11px 15px "
            ><img
              style="width:20px;height:20px"
              src="../../assets/锁.png"/></span

          ><input
            type="password"
            v-model="passWordInfo"
            placeholder="请输入密码"
            style="border:none;width:450px;height:38px;text-indent:10px;"
          />
        </li>

        <li style="text-align:right;margin-top:30px"></li>
      </ul>
      <p
        style="text-align:left;margin:10px 0 0 0;border-top: 1px solid #3f4954;padding:10px 0 0 0"
      >
        <el-button
          type="primary"
          class="login-btn"
          style="width:5em;height:30px;padding:0;float:right;margin:0 60px 0 0;text-align: center;"
          @click="validateLogon()"
          >登录</el-button
        >
      </p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import { mapState } from "vuex";

import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";

export default {
  data() {
    return {
      userInfo: "", //用户名
      passWordInfo: "" //密码
      // checkCode:'',
    };
  },
  mounted() {
    sessionStorage.clear();
  },
  methods: {
    enterMenthod() {
      var that = this;
      var focus = document.getElementById("focus");
      focus.onkeypress = function(event) {
        if (event.which === 13) {
          that.validateLogon();
        }
      };
    },
    //登录方法
    validateLogon() {
      var that = this;
      if (that.userInfo != "" && that.passWordInfo != "") {
        var salesInfoData = {
          lx: 1,
          user_name: that.userInfo, //用户名
          pass: that.passWordInfo //密码
        };
        var salesInfoParams = {
          methodUrl: "admin/webLogin",
          jsonParam: qs.stringify(salesInfoData)
        };
        this.$axios.postRequest(salesInfoParams).then(
          function(res) {
            //成功之后处理逻辑

            if (res.code == "0") {
              sessionStorage.setItem("userData", qs.stringify(res.data));
              if (res.data.role_lx == 1) {
                that.$router.push({ path: "./home" });
              } else if (res.data.role_lx == 2) {
                that.$router.push({ path: "./home" });
              }
            } else if (res.code == "-1001") {
              that.$message({
                showClose: true,
                message: "用户名密码错误",
                type: "warning"
              });
            }
          },
          function(res) {
            //失败之后处理逻辑
            console.log("error:");
          }
        );
      } else {
        if (that.userInfo == "" && that.passWordInfo == "") {
          that.$message({
            showClose: true,
            message: "请输入用户名和密码",
            type: "warning"
          });
        } else if (that.passWordInfo == "") {
          that.$message({
            showClose: true,
            message: "请输入密码",
            type: "warning"
          });
        } else {
          that.$message({
            showClose: true,
            message: "请输入用户名",
            type: "warning"
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.wasder {
  position: absolute;
  z-index: 110;
}

.wai {
  margin: 0;
  height: 100%;
  background-image: url("../../assets/back2.png");
  background-size: 100% 100%;
}
.login {
  width: 35%;
  min-width: 600px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  position: absolute;
  left: 32%;
  top: 20%;
  /* margin: -150px 0 0 -150px; */
  z-index: 99;
  text-align: center;
}
#code {
  height: 30px;
  font-family: Arial, 宋体;
  font-style: italic;
  color: green;
  border: 0;
  padding: 2px 3px;
  letter-spacing: 3px;
  font-weight: bolder;
}
</style>

<style>
.login-btn span{
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/headerMenuLogin/pageLogin.vue